export default {
  estaCarregando: false,
  filtros: {
    curso: null,
    livro: null,
    instrutor: null,
    modalidade_turma: [],
    turnos: [],
    situacao_turma: [],
    dia_semana: [],
    mostrar_alunos: true
  }
}
